// close icon from andt icons
import {CloseOutlined} from '@ant-design/icons';
import styled from '@emotion/styled';

const StyledIcon = styled(CloseOutlined)`
  font-size: 20px;
  color: #000;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const CloseButton = ({onClick}) => {
    return (
        <StyledIcon
            onClick={onClick}
        />
    );
}
